import OutrightScoreboardImpl from './outright-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A View that displays an outright scoreboard.
 *
 * @class OutrightScoreboard
 * @name outright
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * `OutrightScoreboard` prop types.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.outright
 */
const propTypes = { ...getPropTypes() };

export default UIView('OutrightScoreboard', OutrightScoreboardImpl, propTypes);
